import React, { FC } from 'react';

import { ProductListingCardSmall } from 'components/ProductListingCardSmall/ProductListingCardSmall';
import { SearchResult } from 'models/search';

import { Card } from './Card';

export const RelatedProductCard: FC<{
  product: SearchResult;
}> = ({ product }) => {
  return (
    <>
      <Card>
        <ProductListingCardSmall product={product} />
      </Card>
    </>
  );
};
